import React from 'react';
import { useQuery } from '@tanstack/react-query';
import HistoryFeed from '../../ui/data/history/HistoryFeed';
import DetailsCard from '../../ui/layout/DetailsCard';
import { fetchTestCycleHistory } from '../../modules/testcycles';

const TestCycleHistory = ({ entityId }) => {
  const { data = [], isLoading } = useQuery({
    queryKey: ['testcycle-history', entityId],
    queryFn: async () => {
      const res = await fetchTestCycleHistory(entityId);
      return res.data || [];
    },
    enabled: !!entityId,
    staleTime: 1000 * 60 * 5,
  });

  return (
    <DetailsCard title="Test Cycle History">
      <HistoryFeed entries={data} isLoading={isLoading} />
    </DetailsCard>
  );
};

export default TestCycleHistory;